export default __webpack_public_path__ + "static/media/s2.8152a5a3.jpg";